import Vue from "vue";

import lang from "element-ui/lib/locale/lang/es";
import locale from "element-ui/lib/locale";

locale.use(lang);

import {
  Icon,
  Form,
  FormItem,
  Button,
  Input,
  InputNumber,
  Notification,
  Menu,
  MenuItem,
  Loading,
  Row,
  Col,
  Link,
  Table,
  TableColumn,
  Pagination,
  Breadcrumb,
  BreadcrumbItem,
  Checkbox,
  Dialog,
  Select,
  Option,
  Popover,
  Tabs,
  TabPane,
  Steps,
  Step
} from "element-ui";

Vue.use(Icon);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Button);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Loading);
Vue.use(Row);
Vue.use(Col);
Vue.use(Link);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Pagination);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Checkbox);
Vue.use(Dialog);
Vue.use(Select);
Vue.use(Option);
Vue.use(Popover);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Steps);
Vue.use(Step);

Vue.prototype.$notify = Notification;
